import React, { useEffect, useState, useContext } from "react";
import "./ListOrder.scss";
import { formatToPersianAddComma } from "../../../Utils/CommaSeparator";
import { toast } from "react-toastify";
import { SetDiscountContext, SetSaleContext } from "../../pages/Pages";

const ListOrder = ({
	initialData,
	setFactorTotal,
	factorTotal,
	indexNumber,
	total,
	productError,
	setReMake,
}) => {
	const [currentTe, setCurrentTe] = useState("");
	const setSaleNum = useContext(SetSaleContext);
	const discountContext = useContext(SetDiscountContext);
	const [hasError, setHasError] = useState(false);
	const [newTe, setNewTe] = useState("");

	useEffect(() => {
		factorTotal.mainPrice[indexNumber] =
			+initialData.count * +initialData.mainPrice;
		factorTotal.total[indexNumber] =
			+initialData.count * +initialData.mainPrice -
			+initialData.count * +initialData.offerPrice;
		factorTotal.sumTe[indexNumber] = +initialData.count;

		let totalDiscount = 0;
		//alert(discountContext.type)
		if (discountContext.type === "percent") {
			totalDiscount =
				(parseInt(factorTotal.total[indexNumber]) *
					discountContext.value.percent) /
				100;
		} else {
			//alert(discountContext.value)
			totalDiscount = discountContext.value;
		}

		factorTotal.totalDiscount[indexNumber] = totalDiscount;

		factorTotal.discount[indexNumber] =
			+initialData.count * +initialData.offerPrice;

		setFactorTotal({ ...factorTotal });
		setCurrentTe(initialData.count);
	}, [initialData, indexNumber, total, discountContext.value]);

	const handleAddToCart = (data, num) => {
		let pros =
			localStorage.getItem("products") !== ""
				? JSON.parse(localStorage.getItem("products"))
				: [];

		const index = pros.findIndex((item) => item.id === data.id);

		if (index !== -1 && +num > 0.1) {
			pros[index].count = num;
		} else {
			+num > 0.1 && pros.push({ ...data, count: num });
		}

		localStorage.setItem("products", JSON.stringify(pros));
		setSaleNum((prevAmount) => +prevAmount + 1);
	};
	const teHandler = (mode) => {
		let tp;
		if (initialData.type === 1) {
			tp = 1;
		} else {
			tp = +initialData.defultValue;
		}
		if (mode === "up" && currentTe < initialData?.inventory) {
			let newTe = +currentTe + tp;
			setCurrentTe(newTe.toString());

			factorTotal.mainPrice[indexNumber] = newTe * +initialData.mainPrice;
			factorTotal.discount[indexNumber] = newTe * +initialData.offerPrice;
			factorTotal.total[indexNumber] =
				newTe * +initialData.mainPrice -
				newTe * +initialData.offerPrice;

			let totalDiscount = 0;

			if (discountContext.type === "percent") {
				totalDiscount =
					(parseInt(factorTotal.total[indexNumber]) *
						discountContext.value.percent) /
					100;
			} else {
				totalDiscount = discountContext.value;
			}

			factorTotal.totalDiscount[indexNumber] = totalDiscount;

			factorTotal.sumTe[indexNumber] = newTe;
			setFactorTotal({ ...factorTotal });
			handleAddToCart(initialData, newTe);
		} else if (mode === "low") {
			let newTe = +currentTe - tp;
			if (+newTe > 0.1) {
				setCurrentTe(newTe.toString());
				factorTotal.mainPrice[indexNumber] =
					newTe * +initialData.mainPrice;
				factorTotal.discount[indexNumber] =
					newTe * +initialData.offerPrice;
				factorTotal.total[indexNumber] =
					newTe * +initialData.mainPrice -
					newTe * +initialData.offerPrice;

				let totalDiscount = 0;

				if (discountContext.type === "percent") {
					totalDiscount =
						(parseInt(factorTotal.total[indexNumber]) *
							discountContext.value.percent) /
						100;
				} else {
					totalDiscount = discountContext.value;
				}

				factorTotal.totalDiscount[indexNumber] = totalDiscount;

				factorTotal.sumTe[indexNumber] = newTe;
				setFactorTotal({ ...factorTotal });
				handleAddToCart(initialData, newTe);
			} else {
				toast.error("کمتر از این مقدار امکان پذیر نیست");
			}
		} else {
			toast.error("موجودی کافی نیست");
		}
	};

	const deleteOrderHandler = (data) => {
		let pros = JSON.parse(localStorage.getItem("products"));

		const index = pros.findIndex((v) => v.id === data.id);

		if (index !== -1) {
			pros = pros.filter((el) => el.id !== data.id);
		}
		factorTotal.mainPrice.splice(indexNumber, 1);
		factorTotal.discount.splice(indexNumber, 1);
		factorTotal.sumTe.splice(indexNumber, 1);
		factorTotal.total.splice(indexNumber, 1);
		factorTotal.totalDiscount.splice(indexNumber, 1);
		localStorage.setItem("products", JSON.stringify(pros));
		setSaleNum((prevNum) => +prevNum - 1);
		setReMake(Math.random());
	};

	useEffect(() => {
		if (productError !== undefined && productError.length > 0) {
			productError.forEach((v) => {
				if (+v.id === +initialData.id) {
					setHasError(true);
					setNewTe(v.count);
				} else {
					setHasError(false);
				}
				if (initialData.count <= initialData.inventory) {
					setHasError(false);
				}
			});
		}
	}, [productError, initialData]);

	return (
		<div
			className="main-list-order"
			style={hasError ? { border: "1px solid #ff8787" } : {}}
		>
			<div className="order-img">
				<img src={initialData?.images[0]?.url} alt="" />
			</div>

			<h4>{initialData?.title}</h4>

			<div
				className="new-te-row"
				style={hasError ? { display: "flex" } : { display: "none" }}
			>
				<p>موجودی :</p>
				<h6>
					{newTe !== "ناموجود"
						? +newTe < 0
							? "0"
							: Math.floor(+newTe)
						: "ناموجود"}
				</h6>
			</div>

			<div className="small-box">
				<div className="row-in-box">
					{initialData?.type === 1 ? (
						<p>تعداد: </p>
					) : (
						<p>وزن (برحسب کیلوگرم): </p>
					)}
					<div className="box-counter">
						<div
							className="icon-box"
							id="up"
							onClick={() => teHandler("up")}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="10"
								height="10"
								fill="none"
								viewBox="0 0 10 10"
							>
								<g
									fill="#40B2AA"
									clipPath="url(#clip0_1126_20311)"
								>
									<path d="M9 5.75H1C.59 5.75.25 5.41.25 5s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75z"></path>
									<path d="M5 9.75c-.41 0-.75-.34-.75-.75V1c0-.41.34-.75.75-.75s.75.34.75.75v8c0 .41-.34.75-.75.75z"></path>
								</g>
								<defs>
									<clipPath id="clip0_1126_20311">
										<path
											fill="#fff"
											d="M0 0H10V10H0z"
										></path>
									</clipPath>
								</defs>
							</svg>
						</div>

						<input
							value={
								initialData?.type === 2
									? (+currentTe).toFixed(1)
									: currentTe
							}
							readOnly
						/>

						<button
							className="icon-box"
							id="low"
							onClick={() => teHandler("low")}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="10"
								height="10"
								viewBox="0 0 10 10"
								fill="none"
							>
								<path
									d="M9 5.75H1C0.59 5.75 0.25 5.41 0.25 5C0.25 4.59 0.59 4.25 1 4.25H9C9.41 4.25 9.75 4.59 9.75 5C9.75 5.41 9.41 5.75 9 5.75Z"
									fill="#40B2AA"
								/>
							</svg>{" "}
						</button>
					</div>
				</div>

				<div className="row-in-box">
					<p>قیمت :</p>

					<div className="inline-price">
						<p className="off-price">
							{initialData.offer &&
								formatToPersianAddComma(
									Math.floor(
										+initialData?.mainPrice -
											+initialData?.offerPrice
									)
								)}
						</p>
						<p
							style={
								initialData?.offer
									? { textDecorationLine: "line-through" }
									: {}
							}
						>
							{formatToPersianAddComma(
								Math.floor(initialData?.mainPrice)
							)}
						</p>
						<p className="display-none-RP">ریال</p>
					</div>
				</div>
				<div className="row-in-box">
					<p>جمع کل :</p>

					<div className="inline-price">
						<p className="off-price">
							{initialData.offer &&
								formatToPersianAddComma(
									Math.floor(
										(+initialData?.mainPrice -
											+initialData?.offerPrice) *
											+currentTe
									)
								)}
						</p>
						<p
							style={
								initialData?.offer
									? { textDecorationLine: "line-through" }
									: {}
							}
						>
							{formatToPersianAddComma(
								Math.floor(initialData?.mainPrice * +currentTe)
							)}
						</p>
						<p className="display-none-RP">ریال</p>
					</div>
				</div>
			</div>

			<div
				className="delete-order"
				onClick={() => deleteOrderHandler(initialData)}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					fill="none"
					viewBox="0 0 24 24"
				>
					<g
						stroke="#EB455F"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="1.5"
					>
						<path d="M13.99 10.01l.84-.84"></path>
						<path d="M9.17 14.83l2.75-2.75"></path>
						<path d="M14.83 14.83L9.17 9.17"></path>
						<path d="M4 6c-1.25 1.67-2 3.75-2 6 0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2c-1.43 0-2.8.3-4.03.85"></path>
					</g>
				</svg>
			</div>
		</div>
	);
};
export default ListOrder;
